// extracted by mini-css-extract-plugin
export default {"wrapper":"Kw-z","viewport":"Lw-z","container":"Mw-z","slide":"Nw-z"};